import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthProvider';

function Protected({ children }) {
  const { isLoggedIn, isAuthReady } = useContext(AuthContext);

  if (!isAuthReady) return null;

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default Protected;
